<template>
  <div class="banner-single-Post">
    <img
      :src="post.imgUrl"
      alt="Banner single Post"
      class="w-full h-60 object-cover"
    />
  </div>
  <div class="grid grid-cols-4 lg:mx-32 mx-5 my-10 gap-3">
    <!-- Column left -->
    <div class="col-span-3">
      <div class="content-post">
        <div class="grid grid-cols-4 gap-5">
          <div class="img-post col-span-1">
            <img :src="post.imgUrl" alt="" />
          </div>
          <div class="info-post col-span-3">
            <h1 class="text-primary text-3xl mb-3">{{ post.title }}</h1>
            <div class="content-post__info flex flex-col">
              <span class="text-sm">Author: {{ post.author }}</span>
              <span class="text-sm">Date: {{ post.createAt }}</span>
            </div>
          </div>
        </div>
        <div class="content-post__text mt-10" v-html="post.content"></div>
        <div class="tags mt-10">
          <span class="font-bold">Tags:</span> {{ post.tags }}
        </div>
      </div>
    </div>
    <!-- Column right -->
    <div class="col-span-1">
      <div class="recent-post bg-blue-400 px-5 py-5">
        <h2 class="text-2xl text-blue-400 mb-5">Recent Post</h2>
        <div
          class="recent-post__list"
          v-for="(post, index) in Posts"
          :key="index"
        >
          <div class="item-post flex mb-5" :class="`post-${index}`">
            <router-link :to="`/single-post/${post.id}`" class="flex">
              <div class="img-post">
                <img
                  class="w-60px h-100px object-cover mr-3"
                  :src="basePostUrl + post.imgUrl"
                  alt=""
                />
              </div>
              <div class="detail-post">
                <h4>{{ post.title }}</h4>
                <p>Author: {{ post.author }}</p>
                <span>Date: {{ formatDate(post.createAt) }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from "../../assets/Methods";

export default {
  data() {
    return {
      post: {
        imgUrl:
          "https://i.pinimg.com/originals/f5/a7/e5/f5a7e5849ba31101a60c242ed6f857e6.gif",
      },
      basePostUrl: this.$store.state.basePostUrl,
      Posts: [],
      fullImage: false,
      isError: false,
      isSuccess: false,
      isSavedError: false,
    };
  },
  methods: {
    async getPosts() {
      try {
        const res = await this.$store.dispatch("getPosts");
        if (res.status != 200) {
          return;
        }

        if (res.data.length <= 4) {
          this.Posts = res.data;
          return;
        }

        // eslint-disable-next-line for-direction
        for (let i = res.data.length; i > res.data.length - 4; i--) {
          this.Posts.push(res.data[i - 1]);
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getSinglePost(_id) {
      let id;
      if (_id) {
        id = _id;
      } else {
        id = this.$route.params.id;
      }

      const res = await this.$store.dispatch("getPostById", id);
      if (res.status != 200) {
        this.$router.push({ name: "PageNotFound" });
      }

      res.data.createAt = dateFormat(res.data.createAt);
      res.data.imgUrl = this.$store.state.basePostUrl + res.data.imgUrl;
      this.post = res.data;
      window.scrollTo(0, 0);
    },

    formatDate(date) {
      return (date = dateFormat(date));
    },
  },
  async mounted() {
    /* get post by id */
    await this.getSinglePost();
    /* get more Posts */
    await this.getPosts();
  },
};
</script>
<style scoped lang="css">
.bg-blue-400 {
  background-color: rgb(96 165 250 / 0.1);
}
.w-60px {
  width: 60px;
}
.h-100px {
  height: 100px;
}
</style>
